"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import UserPageIdentityAddStatementsSocialMediaAccountHeader from "./UserPageIdentityAddStatementsSocialMediaAccountHeader";
import type { SOCIAL_MEDIA_ACCOUNT_STATEMENT_TYPE } from "@/helpers/Types";
import { STATEMENT_GROUP, STATEMENT_TYPE } from "@/helpers/Types";
import UserPageIdentityAddStatementsSocialMediaAccountItems from "./UserPageIdentityAddStatementsSocialMediaAccountItems";
import UserPageIdentityAddStatementsForm from "@/components/user/identity/statements/utils/UserPageIdentityAddStatementsForm";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
export default function UserPageIdentityAddStatementsSocialMediaAccount(t0) {
  const $ = _c(12);
  const {
    onClose,
    profile
  } = t0;
  const [socialMediaType, setSocialMediaType] = useState(STATEMENT_TYPE.X);
  const group = STATEMENT_GROUP.SOCIAL_MEDIA_ACCOUNT;
  let t1;
  if ($[0] !== onClose) {
    t1 = <UserPageIdentityAddStatementsSocialMediaAccountHeader onClose={onClose} />;
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== socialMediaType) {
    t2 = <UserPageIdentityAddStatementsSocialMediaAccountItems activeType={socialMediaType} setSocialType={setSocialMediaType} />;
    $[2] = socialMediaType;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onClose || $[5] !== profile || $[6] !== socialMediaType) {
    t3 = <UserPageIdentityAddStatementsForm activeType={socialMediaType} group={group} profile={profile} onClose={onClose} />;
    $[4] = onClose;
    $[5] = profile;
    $[6] = socialMediaType;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <>{t1}{t2}{t3}</>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}